<template>
  <div class="cp-bg">
    <section class="section">
      <div class="container">
        <slot/>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'LayoutHome'
  }
</script>
